import { isIndividualEvent } from '@/api/events/types/types';
import { PlayerWithTeamAndEvent } from '@/feature/betslip-pickem/types';
import { getPlayerPositionOrRank } from '@/utils/formatPlayerInfo';
import { isPGA, isUFC } from '@/utils/league';

export const PLAYER_PROFILE_EVENT_WIDGET_PLACEHOLDER_SIZE = { width: 40, height: 40 };
export const CONTAINER_SIZE = { width: 112, height: 112 };
export const PADDING_RIGHT_PLAYER_IMAGE = 32;
export const PADDING_HORIZONTAL = 16;

export const getPlayerDisplayDetails = (playerInfo: PlayerWithTeamAndEvent): string => {
    const event = playerInfo?.event;

    if (!event) {
        return '';
    }

    const isIndividual = isIndividualEvent(event);
    const league = event?.league;
    const position = getPlayerPositionOrRank(playerInfo, event);
    const record = playerInfo?.record;
    const rank = playerInfo?.rank;

    if (isIndividual) {
        const country = event?.venueDetails?.country ?? '';

        if (isPGA(league)) {
            return [country, position].filter(Boolean).join(' • ');
        }

        if (isUFC(league)) {
            return [record, country, rank ? `#${rank}` : ''].filter(Boolean).join(' • ');
        }

        return '';
    }

    const number = playerInfo.jerseyNumber ? `#${playerInfo.jerseyNumber}` : '';
    const team = playerInfo?.team?.name ?? '';

    return [position, number, team].filter(Boolean).join(' • ');
};
